import styled from 'styled-components'
import { Color } from '../types/styled'

const Root = styled.button<{color: Color, variant: 'contained' | 'outlined', size: 'small' | 'regular', fullwidth: boolean}>`
  display: inline-flex;
  justify-content: center;
  align-items: center;
  box-sizing: border-box;
  width: ${({ fullwidth }) => fullwidth && '100%'};
  height: ${({ size }) => size === 'small' ? '24px' : '41px'};
  padding: ${({ size }) => size === 'small' ? '0 10px' : '9px 18px'};
  font-size: ${({ size }) => size === 'small' ? '12px' : 'inherit'};
  text-align: center;
  transition: background-color 0.2s;
  border: none;
  color: ${({ variant, theme }) => variant === 'outlined' ? theme.color.secondary : '#FFFFFF'};
  background-color: ${props => props.variant === 'contained' && props.disabled
    ? props.theme.color.button.bg.disabled
    : props.variant === 'contained' ? props.theme.color.button.bg[props.color] : 'transparent'};
  border: ${props => props.variant === 'outlined' && props.disabled
    ? `2px solid ${props.theme.color.button.bg.disabled}`
    : props.variant === 'outlined' ? `2px solid ${props.theme.color.button.bg[props.color]}` : 'none'};
  border-radius: 4px;
  box-shadow: 0 2px 2px rgba(0, 0, 0, 0.25);
  cursor: pointer;
  user-select: none;
  &:hover {
    transition: background-color 0.1s ease, border-color 0.1s ease;
    background-color: ${props =>
      props.disabled ? props.theme.color.button.bg.disabled
        : props.variant === 'outlined' ? 'transparent'
          : props.theme.color.button.bgHover[props.color]};
    border-color: ${props => props.variant === 'outlined' && !props.disabled
    ? props.theme.color.button.bgHover[props.color]
    : 'inherit'};
  }
`

type Props = React.BaseHTMLAttributes<HTMLButtonElement> & {
  type?: 'button' | 'submit'
  color?: Color
  icon?: React.ReactElement
  variant?: 'contained' | 'outlined'
  size?: 'small' | 'regular'
  loading?: boolean
  disabled?: boolean
  fullwidth?: boolean
}

const Button = (params: React.PropsWithChildren<Props>) => {
  const {
    type = 'button',
    children,
    icon,
    variant = 'contained',
    color = 'primary',
    size = 'regular',
    loading,
    disabled = false,
    fullwidth = false,
    ...rest
  } = params

  return (
    <Root type={type} color={color} variant={variant} size={size} disabled={loading || disabled} fullwidth={fullwidth} {...rest}>
      {icon && icon}
      {children}
    </Root>
  )
}

export { Button }